"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeightsC = exports.FiltersC = void 0;
const t = __importStar(require("io-ts"));
const types_1 = require("./types");
exports.FiltersC = t.partial({
    iso3166: types_1.FilterC,
    orgnr: types_1.FilterC,
    companyMasterSysPeriod: types_1.FilterC,
    likelihoodToMoveScore: types_1.FilterC,
    legalEntityType: types_1.FilterC,
    address: types_1.FilterC,
    zipcode: types_1.FilterC,
    city: types_1.FilterC,
    muncipality: types_1.FilterC,
    county: types_1.FilterC,
    region: types_1.FilterC,
    website: types_1.FilterC,
    phone: types_1.FilterC,
    email: types_1.FilterC,
    registrationDate: types_1.FilterC,
    companyCategory: types_1.FilterC,
    companyStructure: types_1.FilterC,
    legalForm: types_1.FilterC,
    listingType: types_1.FilterC,
    descriptionEn: types_1.FilterC,
    operationalStatus: types_1.FilterC,
    owners: types_1.FilterC,
    keyPersons: types_1.FilterC,
    signatory: types_1.FilterC,
    parentCompanyName: types_1.FilterC,
    previousNames: types_1.FilterC,
    accountantFirm: types_1.FilterC,
    hasPrivateEquityOwner: types_1.FilterC,
    privateEquityOwner: types_1.FilterC,
    lfy: types_1.FilterC,
    lrq: types_1.FilterC,
    ceo: types_1.FilterC,
    ceoBirthYear: types_1.FilterC,
    chairman: types_1.FilterC,
    chairmanBirthYear: types_1.FilterC,
    hasShareIssues: types_1.FilterC,
    numberOfOwners: types_1.FilterC,
    numberOfShares: types_1.FilterC,
    hasForeignUltimateParent: types_1.FilterC,
    ultimateParentCompany: types_1.FilterC,
    ultimateParentOrgNo: types_1.FilterC,
    ultimateParentNetSales: types_1.FilterC,
    companyName: types_1.FilterC,
    sniClassification: types_1.FilterC,
    sniClassificationCode: types_1.FilterC,
    financialsUpdatedDate: types_1.FilterC,
    lastUpdated: types_1.FilterC,
    companyKeywords: types_1.FilterC,
    fiscalYear: types_1.FilterC,
    currency: types_1.FilterC,
    netSales: types_1.FilterC,
    costOfSales: types_1.FilterC,
    grossProfit: types_1.FilterC,
    administrativeExpenses: types_1.FilterC,
    sellingExpenses: types_1.FilterC,
    otherExternalExpenses: types_1.FilterC,
    personelExpenses: types_1.FilterC,
    ebit: types_1.FilterC,
    ebita: types_1.FilterC,
    ebitd: types_1.FilterC,
    ebitda: types_1.FilterC,
    deprAmo: types_1.FilterC,
    depreciation: types_1.FilterC,
    amortisation: types_1.FilterC,
    netFinancialIncomeOrExpenses: types_1.FilterC,
    financialIncome: types_1.FilterC,
    financialExpenses: types_1.FilterC,
    preTaxProfit: types_1.FilterC,
    netProfit: types_1.FilterC,
    cashEquivalents: types_1.FilterC,
    accRec: types_1.FilterC,
    inventories: types_1.FilterC,
    othCurrOpAss: types_1.FilterC,
    currFinAss: types_1.FilterC,
    totalCurrentAssets: types_1.FilterC,
    ppe: types_1.FilterC,
    goodwillIntangAss: types_1.FilterC,
    nCurrFinRec: types_1.FilterC,
    othNCurrOpAss: types_1.FilterC,
    totalNonCurrentAssets: types_1.FilterC,
    totalAssets: types_1.FilterC,
    accPay: types_1.FilterC,
    currFinLiab: types_1.FilterC,
    postEmplLiab: types_1.FilterC,
    othCurrOpLiab: types_1.FilterC,
    totalCurrentLiabilities: types_1.FilterC,
    othNCurrOpLiab: types_1.FilterC,
    nCurrFinLiab: types_1.FilterC,
    totalNonCurrLiab: types_1.FilterC,
    shareholdEq: types_1.FilterC,
    retainedEarnings: types_1.FilterC,
    minInt: types_1.FilterC,
    totalEquity: types_1.FilterC,
    dividends: types_1.FilterC,
    cashFlowBeforeFinAct: types_1.FilterC,
    cashFlowOperating: types_1.FilterC,
    ebitMargin: types_1.FilterC,
    ebitdaMargin: types_1.FilterC,
    preTaxProfitMargin: types_1.FilterC,
    netProfitMargin: types_1.FilterC,
    roe: types_1.FilterC,
    netCapex: types_1.FilterC,
    netDebt: types_1.FilterC,
    marketCap: types_1.FilterC,
    annualReportNumberOfEmployees: types_1.FilterC,
    fiscalYearLength: types_1.FilterC,
    lfyMonth: types_1.FilterC,
    netChangeInCash: types_1.FilterC,
    netSalesGrowth: types_1.FilterC,
    cagr: types_1.FilterC,
    cagr3: types_1.FilterC,
    ebitGrowth: types_1.FilterC,
    cagr3ebit: types_1.FilterC,
    cagrebit: types_1.FilterC,
    ebitdaGrowth: types_1.FilterC,
    netProfitGrowth: types_1.FilterC,
    eps: types_1.FilterC,
    equityRatio: types_1.FilterC,
    netDebtToEbit: types_1.FilterC,
    netDebtToEbitda: types_1.FilterC,
    netDebtToEquity: types_1.FilterC,
    evToEbit: types_1.FilterC,
    evToEbitda: types_1.FilterC,
    evToNetSales: types_1.FilterC,
    pe: types_1.FilterC,
    ev: types_1.FilterC,
    pbv: types_1.FilterC,
    annualReportEmployeeGrowth: types_1.FilterC,
    fiscalYearLength1YearAgo: types_1.FilterC,
    fiscalYearLength3YearsAgo: types_1.FilterC,
    fiscalYearLength5YearsAgo: types_1.FilterC,
    lfyMonth1YearAgo: types_1.FilterC,
    lfyMonth3YearsAgo: types_1.FilterC,
    lfyMonth5YearsAgo: types_1.FilterC,
    netChangeInCash1YearAgo: types_1.FilterC,
    netChangeInCash3YearsAgo: types_1.FilterC,
    netChangeInCash5YearsAgo: types_1.FilterC,
    netSalesGrowth1YearAgo: types_1.FilterC,
    netSalesGrowth3YearsAgo: types_1.FilterC,
    netSalesGrowth5YearsAgo: types_1.FilterC,
    cagr1YearAgo: types_1.FilterC,
    cagr3YearsAgo: types_1.FilterC,
    cagr5YearsAgo: types_1.FilterC,
    cagr31YearAgo: types_1.FilterC,
    cagr33YearsAgo: types_1.FilterC,
    cagr35YearsAgo: types_1.FilterC,
    ebitGrowth1YearAgo: types_1.FilterC,
    ebitGrowth3YearsAgo: types_1.FilterC,
    ebitGrowth5YearsAgo: types_1.FilterC,
    cagr3ebit1YearAgo: types_1.FilterC,
    cagr3ebit3YearsAgo: types_1.FilterC,
    cagr3ebit5YearsAgo: types_1.FilterC,
    cagrebit1YearAgo: types_1.FilterC,
    cagrebit3YearsAgo: types_1.FilterC,
    cagrebit5YearsAgo: types_1.FilterC,
    ebitdaGrowth1YearAgo: types_1.FilterC,
    ebitdaGrowth3YearsAgo: types_1.FilterC,
    ebitdaGrowth5YearsAgo: types_1.FilterC,
    netProfitGrowth1YearAgo: types_1.FilterC,
    netProfitGrowth3YearsAgo: types_1.FilterC,
    netProfitGrowth5YearsAgo: types_1.FilterC,
    eps1YearAgo: types_1.FilterC,
    eps3YearsAgo: types_1.FilterC,
    eps5YearsAgo: types_1.FilterC,
    equityRatio1YearAgo: types_1.FilterC,
    equityRatio3YearsAgo: types_1.FilterC,
    equityRatio5YearsAgo: types_1.FilterC,
    netDebtToEbit1YearAgo: types_1.FilterC,
    netDebtToEbit3YearsAgo: types_1.FilterC,
    netDebtToEbit5YearsAgo: types_1.FilterC,
    netDebtToEbitda1YearAgo: types_1.FilterC,
    netDebtToEbitda3YearsAgo: types_1.FilterC,
    netDebtToEbitda5YearsAgo: types_1.FilterC,
    netDebtToEquity1YearAgo: types_1.FilterC,
    netDebtToEquity3YearsAgo: types_1.FilterC,
    netDebtToEquity5YearsAgo: types_1.FilterC,
    evToEbit1YearAgo: types_1.FilterC,
    evToEbit3YearsAgo: types_1.FilterC,
    evToEbit5YearsAgo: types_1.FilterC,
    evToEbitda1YearAgo: types_1.FilterC,
    evToEbitda3YearsAgo: types_1.FilterC,
    evToEbitda5YearsAgo: types_1.FilterC,
    evToNetSales1YearAgo: types_1.FilterC,
    evToNetSales3YearsAgo: types_1.FilterC,
    evToNetSales5YearsAgo: types_1.FilterC,
    pe1YearAgo: types_1.FilterC,
    pe3YearsAgo: types_1.FilterC,
    pe5YearsAgo: types_1.FilterC,
    ev1YearAgo: types_1.FilterC,
    ev3YearsAgo: types_1.FilterC,
    ev5YearsAgo: types_1.FilterC,
    pbv1YearAgo: types_1.FilterC,
    pbv3YearsAgo: types_1.FilterC,
    pbv5YearsAgo: types_1.FilterC,
    annualReportEmployeeGrowth1YearAgo: types_1.FilterC,
    annualReportEmployeeGrowth3YearsAgo: types_1.FilterC,
    annualReportEmployeeGrowth5YearsAgo: types_1.FilterC,
    netSales1YearAgo: types_1.FilterC,
    netSales3YearsAgo: types_1.FilterC,
    netSales5YearsAgo: types_1.FilterC,
    costOfSales1YearAgo: types_1.FilterC,
    costOfSales3YearsAgo: types_1.FilterC,
    costOfSales5YearsAgo: types_1.FilterC,
    grossProfit1YearAgo: types_1.FilterC,
    grossProfit3YearsAgo: types_1.FilterC,
    grossProfit5YearsAgo: types_1.FilterC,
    administrativeExpenses1YearAgo: types_1.FilterC,
    administrativeExpenses3YearsAgo: types_1.FilterC,
    administrativeExpenses5YearsAgo: types_1.FilterC,
    sellingExpenses1YearAgo: types_1.FilterC,
    sellingExpenses3YearsAgo: types_1.FilterC,
    sellingExpenses5YearsAgo: types_1.FilterC,
    otherExternalExpenses1YearAgo: types_1.FilterC,
    otherExternalExpenses3YearsAgo: types_1.FilterC,
    otherExternalExpenses5YearsAgo: types_1.FilterC,
    personelExpenses1YearAgo: types_1.FilterC,
    personelExpenses3YearsAgo: types_1.FilterC,
    personelExpenses5YearsAgo: types_1.FilterC,
    ebit1YearAgo: types_1.FilterC,
    ebit3YearsAgo: types_1.FilterC,
    ebit5YearsAgo: types_1.FilterC,
    ebita1YearAgo: types_1.FilterC,
    ebita3YearsAgo: types_1.FilterC,
    ebita5YearsAgo: types_1.FilterC,
    ebitd1YearAgo: types_1.FilterC,
    ebitd3YearsAgo: types_1.FilterC,
    ebitd5YearsAgo: types_1.FilterC,
    ebitda1YearAgo: types_1.FilterC,
    ebitda3YearsAgo: types_1.FilterC,
    ebitda5YearsAgo: types_1.FilterC,
    deprAmo1YearAgo: types_1.FilterC,
    deprAmo3YearsAgo: types_1.FilterC,
    deprAmo5YearsAgo: types_1.FilterC,
    depreciation1YearAgo: types_1.FilterC,
    depreciation3YearsAgo: types_1.FilterC,
    depreciation5YearsAgo: types_1.FilterC,
    amortisation1YearAgo: types_1.FilterC,
    amortisation3YearsAgo: types_1.FilterC,
    amortisation5YearsAgo: types_1.FilterC,
    netFinancialIncomeOrExpenses1YearAgo: types_1.FilterC,
    netFinancialIncomeOrExpenses3YearsAgo: types_1.FilterC,
    netFinancialIncomeOrExpenses5YearsAgo: types_1.FilterC,
    financialIncome1YearAgo: types_1.FilterC,
    financialIncome3YearsAgo: types_1.FilterC,
    financialIncome5YearsAgo: types_1.FilterC,
    financialExpenses1YearAgo: types_1.FilterC,
    financialExpenses3YearsAgo: types_1.FilterC,
    financialExpenses5YearsAgo: types_1.FilterC,
    preTaxProfit1YearAgo: types_1.FilterC,
    preTaxProfit3YearsAgo: types_1.FilterC,
    preTaxProfit5YearsAgo: types_1.FilterC,
    netProfit1YearAgo: types_1.FilterC,
    netProfit3YearsAgo: types_1.FilterC,
    netProfit5YearsAgo: types_1.FilterC,
    cashEquivalents1YearAgo: types_1.FilterC,
    cashEquivalents3YearsAgo: types_1.FilterC,
    cashEquivalents5YearsAgo: types_1.FilterC,
    accRec1YearAgo: types_1.FilterC,
    accRec3YearsAgo: types_1.FilterC,
    accRec5YearsAgo: types_1.FilterC,
    inventories1YearAgo: types_1.FilterC,
    inventories3YearsAgo: types_1.FilterC,
    inventories5YearsAgo: types_1.FilterC,
    othCurrOpAss1YearAgo: types_1.FilterC,
    othCurrOpAss3YearsAgo: types_1.FilterC,
    othCurrOpAss5YearsAgo: types_1.FilterC,
    currFinAss1YearAgo: types_1.FilterC,
    currFinAss3YearsAgo: types_1.FilterC,
    currFinAss5YearsAgo: types_1.FilterC,
    totalCurrentAssets1YearAgo: types_1.FilterC,
    totalCurrentAssets3YearsAgo: types_1.FilterC,
    totalCurrentAssets5YearsAgo: types_1.FilterC,
    ppe1YearAgo: types_1.FilterC,
    ppe3YearsAgo: types_1.FilterC,
    ppe5YearsAgo: types_1.FilterC,
    goodwillIntangAss1YearAgo: types_1.FilterC,
    goodwillIntangAss3YearsAgo: types_1.FilterC,
    goodwillIntangAss5YearsAgo: types_1.FilterC,
    nCurrFinRec1YearAgo: types_1.FilterC,
    nCurrFinRec3YearsAgo: types_1.FilterC,
    nCurrFinRec5YearsAgo: types_1.FilterC,
    othNCurrOpAss1YearAgo: types_1.FilterC,
    othNCurrOpAss3YearsAgo: types_1.FilterC,
    othNCurrOpAss5YearsAgo: types_1.FilterC,
    totalNonCurrentAssets1YearAgo: types_1.FilterC,
    totalNonCurrentAssets3YearsAgo: types_1.FilterC,
    totalNonCurrentAssets5YearsAgo: types_1.FilterC,
    totalAssets1YearAgo: types_1.FilterC,
    totalAssets3YearsAgo: types_1.FilterC,
    totalAssets5YearsAgo: types_1.FilterC,
    accPay1YearAgo: types_1.FilterC,
    accPay3YearsAgo: types_1.FilterC,
    accPay5YearsAgo: types_1.FilterC,
    currFinLiab1YearAgo: types_1.FilterC,
    currFinLiab3YearsAgo: types_1.FilterC,
    currFinLiab5YearsAgo: types_1.FilterC,
    postEmplLiab1YearAgo: types_1.FilterC,
    postEmplLiab3YearsAgo: types_1.FilterC,
    postEmplLiab5YearsAgo: types_1.FilterC,
    othCurrOpLiab1YearAgo: types_1.FilterC,
    othCurrOpLiab3YearsAgo: types_1.FilterC,
    othCurrOpLiab5YearsAgo: types_1.FilterC,
    totalCurrentLiabilities1YearAgo: types_1.FilterC,
    totalCurrentLiabilities3YearsAgo: types_1.FilterC,
    totalCurrentLiabilities5YearsAgo: types_1.FilterC,
    othNCurrOpLiab1YearAgo: types_1.FilterC,
    othNCurrOpLiab3YearsAgo: types_1.FilterC,
    othNCurrOpLiab5YearsAgo: types_1.FilterC,
    nCurrFinLiab1YearAgo: types_1.FilterC,
    nCurrFinLiab3YearsAgo: types_1.FilterC,
    nCurrFinLiab5YearsAgo: types_1.FilterC,
    totalNonCurrLiab1YearAgo: types_1.FilterC,
    totalNonCurrLiab3YearsAgo: types_1.FilterC,
    totalNonCurrLiab5YearsAgo: types_1.FilterC,
    shareholdEq1YearAgo: types_1.FilterC,
    shareholdEq3YearsAgo: types_1.FilterC,
    shareholdEq5YearsAgo: types_1.FilterC,
    retainedEarnings1YearAgo: types_1.FilterC,
    retainedEarnings3YearsAgo: types_1.FilterC,
    retainedEarnings5YearsAgo: types_1.FilterC,
    minInt1YearAgo: types_1.FilterC,
    minInt3YearsAgo: types_1.FilterC,
    minInt5YearsAgo: types_1.FilterC,
    totalEquity1YearAgo: types_1.FilterC,
    totalEquity3YearsAgo: types_1.FilterC,
    totalEquity5YearsAgo: types_1.FilterC,
    dividends1YearAgo: types_1.FilterC,
    dividends3YearsAgo: types_1.FilterC,
    dividends5YearsAgo: types_1.FilterC,
    cashFlowBeforeFinAct1YearAgo: types_1.FilterC,
    cashFlowBeforeFinAct3YearsAgo: types_1.FilterC,
    cashFlowBeforeFinAct5YearsAgo: types_1.FilterC,
    cashFlowOperating1YearAgo: types_1.FilterC,
    cashFlowOperating3YearsAgo: types_1.FilterC,
    cashFlowOperating5YearsAgo: types_1.FilterC,
    ebitMargin1YearAgo: types_1.FilterC,
    ebitMargin3YearsAgo: types_1.FilterC,
    ebitMargin5YearsAgo: types_1.FilterC,
    ebitdaMargin1YearAgo: types_1.FilterC,
    ebitdaMargin3YearsAgo: types_1.FilterC,
    ebitdaMargin5YearsAgo: types_1.FilterC,
    preTaxProfitMargin1YearAgo: types_1.FilterC,
    preTaxProfitMargin3YearsAgo: types_1.FilterC,
    preTaxProfitMargin5YearsAgo: types_1.FilterC,
    netProfitMargin1YearAgo: types_1.FilterC,
    netProfitMargin3YearsAgo: types_1.FilterC,
    netProfitMargin5YearsAgo: types_1.FilterC,
    roe1YearAgo: types_1.FilterC,
    roe3YearsAgo: types_1.FilterC,
    roe5YearsAgo: types_1.FilterC,
    netCapex1YearAgo: types_1.FilterC,
    netCapex3YearsAgo: types_1.FilterC,
    netCapex5YearsAgo: types_1.FilterC,
    netDebt1YearAgo: types_1.FilterC,
    netDebt3YearsAgo: types_1.FilterC,
    netDebt5YearsAgo: types_1.FilterC,
    marketCap1YearAgo: types_1.FilterC,
    marketCap3YearsAgo: types_1.FilterC,
    marketCap5YearsAgo: types_1.FilterC,
    annualReportNumberOfEmployees1YearAgo: types_1.FilterC,
    annualReportNumberOfEmployees3YearsAgo: types_1.FilterC,
    annualReportNumberOfEmployees5YearsAgo: types_1.FilterC,
    netSalesGrowth1Year: types_1.FilterC,
    netSalesGrowth3Years: types_1.FilterC,
    netSalesGrowth5Years: types_1.FilterC,
    costOfSalesGrowth1Year: types_1.FilterC,
    costOfSalesGrowth3Years: types_1.FilterC,
    costOfSalesGrowth5Years: types_1.FilterC,
    grossProfitGrowth1Year: types_1.FilterC,
    grossProfitGrowth3Years: types_1.FilterC,
    grossProfitGrowth5Years: types_1.FilterC,
    administrativeExpensesGrowth1Year: types_1.FilterC,
    administrativeExpensesGrowth3Years: types_1.FilterC,
    administrativeExpensesGrowth5Years: types_1.FilterC,
    sellingExpensesGrowth1Year: types_1.FilterC,
    sellingExpensesGrowth3Years: types_1.FilterC,
    sellingExpensesGrowth5Years: types_1.FilterC,
    otherExternalExpensesGrowth1Year: types_1.FilterC,
    otherExternalExpensesGrowth3Years: types_1.FilterC,
    otherExternalExpensesGrowth5Years: types_1.FilterC,
    personelExpensesGrowth1Year: types_1.FilterC,
    personelExpensesGrowth3Years: types_1.FilterC,
    personelExpensesGrowth5Years: types_1.FilterC,
    ebitGrowth1Year: types_1.FilterC,
    ebitGrowth3Years: types_1.FilterC,
    ebitGrowth5Years: types_1.FilterC,
    ebitaGrowth1Year: types_1.FilterC,
    ebitaGrowth3Years: types_1.FilterC,
    ebitaGrowth5Years: types_1.FilterC,
    ebitdGrowth1Year: types_1.FilterC,
    ebitdGrowth3Years: types_1.FilterC,
    ebitdGrowth5Years: types_1.FilterC,
    ebitdaGrowth1Year: types_1.FilterC,
    ebitdaGrowth3Years: types_1.FilterC,
    ebitdaGrowth5Years: types_1.FilterC,
    deprAmoGrowth1Year: types_1.FilterC,
    deprAmoGrowth3Years: types_1.FilterC,
    deprAmoGrowth5Years: types_1.FilterC,
    depreciationGrowth1Year: types_1.FilterC,
    depreciationGrowth3Years: types_1.FilterC,
    depreciationGrowth5Years: types_1.FilterC,
    amortisationGrowth1Year: types_1.FilterC,
    amortisationGrowth3Years: types_1.FilterC,
    amortisationGrowth5Years: types_1.FilterC,
    netFinancialIncomeOrExpensesGrowth1Year: types_1.FilterC,
    netFinancialIncomeOrExpensesGrowth3Years: types_1.FilterC,
    netFinancialIncomeOrExpensesGrowth5Years: types_1.FilterC,
    financialIncomeGrowth1Year: types_1.FilterC,
    financialIncomeGrowth3Years: types_1.FilterC,
    financialIncomeGrowth5Years: types_1.FilterC,
    financialExpensesGrowth1Year: types_1.FilterC,
    financialExpensesGrowth3Years: types_1.FilterC,
    financialExpensesGrowth5Years: types_1.FilterC,
    preTaxProfitGrowth1Year: types_1.FilterC,
    preTaxProfitGrowth3Years: types_1.FilterC,
    preTaxProfitGrowth5Years: types_1.FilterC,
    netProfitGrowth1Year: types_1.FilterC,
    netProfitGrowth3Years: types_1.FilterC,
    netProfitGrowth5Years: types_1.FilterC,
    cashEquivalentsGrowth1Year: types_1.FilterC,
    cashEquivalentsGrowth3Years: types_1.FilterC,
    cashEquivalentsGrowth5Years: types_1.FilterC,
    accRecGrowth1Year: types_1.FilterC,
    accRecGrowth3Years: types_1.FilterC,
    accRecGrowth5Years: types_1.FilterC,
    inventoriesGrowth1Year: types_1.FilterC,
    inventoriesGrowth3Years: types_1.FilterC,
    inventoriesGrowth5Years: types_1.FilterC,
    othCurrOpAssGrowth1Year: types_1.FilterC,
    othCurrOpAssGrowth3Years: types_1.FilterC,
    othCurrOpAssGrowth5Years: types_1.FilterC,
    currFinAssGrowth1Year: types_1.FilterC,
    currFinAssGrowth3Years: types_1.FilterC,
    currFinAssGrowth5Years: types_1.FilterC,
    totalCurrentAssetsGrowth1Year: types_1.FilterC,
    totalCurrentAssetsGrowth3Years: types_1.FilterC,
    totalCurrentAssetsGrowth5Years: types_1.FilterC,
    ppeGrowth1Year: types_1.FilterC,
    ppeGrowth3Years: types_1.FilterC,
    ppeGrowth5Years: types_1.FilterC,
    goodwillIntangAssGrowth1Year: types_1.FilterC,
    goodwillIntangAssGrowth3Years: types_1.FilterC,
    goodwillIntangAssGrowth5Years: types_1.FilterC,
    nCurrFinRecGrowth1Year: types_1.FilterC,
    nCurrFinRecGrowth3Years: types_1.FilterC,
    nCurrFinRecGrowth5Years: types_1.FilterC,
    othNCurrOpAssGrowth1Year: types_1.FilterC,
    othNCurrOpAssGrowth3Years: types_1.FilterC,
    othNCurrOpAssGrowth5Years: types_1.FilterC,
    totalNonCurrentAssetsGrowth1Year: types_1.FilterC,
    totalNonCurrentAssetsGrowth3Years: types_1.FilterC,
    totalNonCurrentAssetsGrowth5Years: types_1.FilterC,
    totalAssetsGrowth1Year: types_1.FilterC,
    totalAssetsGrowth3Years: types_1.FilterC,
    totalAssetsGrowth5Years: types_1.FilterC,
    accPayGrowth1Year: types_1.FilterC,
    accPayGrowth3Years: types_1.FilterC,
    accPayGrowth5Years: types_1.FilterC,
    currFinLiabGrowth1Year: types_1.FilterC,
    currFinLiabGrowth3Years: types_1.FilterC,
    currFinLiabGrowth5Years: types_1.FilterC,
    postEmplLiabGrowth1Year: types_1.FilterC,
    postEmplLiabGrowth3Years: types_1.FilterC,
    postEmplLiabGrowth5Years: types_1.FilterC,
    othCurrOpLiabGrowth1Year: types_1.FilterC,
    othCurrOpLiabGrowth3Years: types_1.FilterC,
    othCurrOpLiabGrowth5Years: types_1.FilterC,
    totalCurrentLiabilitiesGrowth1Year: types_1.FilterC,
    totalCurrentLiabilitiesGrowth3Years: types_1.FilterC,
    totalCurrentLiabilitiesGrowth5Years: types_1.FilterC,
    othNCurrOpLiabGrowth1Year: types_1.FilterC,
    othNCurrOpLiabGrowth3Years: types_1.FilterC,
    othNCurrOpLiabGrowth5Years: types_1.FilterC,
    nCurrFinLiabGrowth1Year: types_1.FilterC,
    nCurrFinLiabGrowth3Years: types_1.FilterC,
    nCurrFinLiabGrowth5Years: types_1.FilterC,
    totalNonCurrLiabGrowth1Year: types_1.FilterC,
    totalNonCurrLiabGrowth3Years: types_1.FilterC,
    totalNonCurrLiabGrowth5Years: types_1.FilterC,
    shareholdEqGrowth1Year: types_1.FilterC,
    shareholdEqGrowth3Years: types_1.FilterC,
    shareholdEqGrowth5Years: types_1.FilterC,
    retainedEarningsGrowth1Year: types_1.FilterC,
    retainedEarningsGrowth3Years: types_1.FilterC,
    retainedEarningsGrowth5Years: types_1.FilterC,
    minIntGrowth1Year: types_1.FilterC,
    minIntGrowth3Years: types_1.FilterC,
    minIntGrowth5Years: types_1.FilterC,
    totalEquityGrowth1Year: types_1.FilterC,
    totalEquityGrowth3Years: types_1.FilterC,
    totalEquityGrowth5Years: types_1.FilterC,
    dividendsGrowth1Year: types_1.FilterC,
    dividendsGrowth3Years: types_1.FilterC,
    dividendsGrowth5Years: types_1.FilterC,
    cashFlowBeforeFinActGrowth1Year: types_1.FilterC,
    cashFlowBeforeFinActGrowth3Years: types_1.FilterC,
    cashFlowBeforeFinActGrowth5Years: types_1.FilterC,
    cashFlowOperatingGrowth1Year: types_1.FilterC,
    cashFlowOperatingGrowth3Years: types_1.FilterC,
    cashFlowOperatingGrowth5Years: types_1.FilterC,
    ebitMarginGrowth1Year: types_1.FilterC,
    ebitMarginGrowth3Years: types_1.FilterC,
    ebitMarginGrowth5Years: types_1.FilterC,
    ebitdaMarginGrowth1Year: types_1.FilterC,
    ebitdaMarginGrowth3Years: types_1.FilterC,
    ebitdaMarginGrowth5Years: types_1.FilterC,
    preTaxProfitMarginGrowth1Year: types_1.FilterC,
    preTaxProfitMarginGrowth3Years: types_1.FilterC,
    preTaxProfitMarginGrowth5Years: types_1.FilterC,
    netProfitMarginGrowth1Year: types_1.FilterC,
    netProfitMarginGrowth3Years: types_1.FilterC,
    netProfitMarginGrowth5Years: types_1.FilterC,
    roeGrowth1Year: types_1.FilterC,
    roeGrowth3Years: types_1.FilterC,
    roeGrowth5Years: types_1.FilterC,
    netCapexGrowth1Year: types_1.FilterC,
    netCapexGrowth3Years: types_1.FilterC,
    netCapexGrowth5Years: types_1.FilterC,
    netDebtGrowth1Year: types_1.FilterC,
    netDebtGrowth3Years: types_1.FilterC,
    netDebtGrowth5Years: types_1.FilterC,
    marketCapGrowth1Year: types_1.FilterC,
    marketCapGrowth3Years: types_1.FilterC,
    marketCapGrowth5Years: types_1.FilterC,
    annualReportNumberOfEmployeesGrowth1Year: types_1.FilterC,
    annualReportNumberOfEmployeesGrowth3Years: types_1.FilterC,
    annualReportNumberOfEmployeesGrowth5Years: types_1.FilterC,
    activeJobposts: types_1.FilterC,
    activeJobposts1WeekAgo: types_1.FilterC,
    activeJobposts1MonthAgo: types_1.FilterC,
    activeJobposts6MonthsAgo: types_1.FilterC,
    activeJobposts1YearAgo: types_1.FilterC,
    activeJobposts3YearsAgo: types_1.FilterC,
    activeJobposts5YearsAgo: types_1.FilterC,
    jobpostsGrowth1Week: types_1.FilterC,
    jobpostsGrowth1Month: types_1.FilterC,
    jobpostsGrowth6Months: types_1.FilterC,
    jobpostsGrowth1Year: types_1.FilterC,
    jobpostsGrowth3Years: types_1.FilterC,
    jobpostsGrowth5Years: types_1.FilterC,
    domainIsVerified: types_1.FilterC,
    domain: types_1.FilterC,
    error: types_1.FilterC,
    pageLoadTimeTti: types_1.FilterC,
    domainSysPeriod: types_1.FilterC,
    ipAddress: types_1.FilterC,
    analyticsUa: types_1.FilterC,
    analyticsGa4: types_1.FilterC,
    analyticsFb: types_1.FilterC,
    gconvpAccount: types_1.FilterC,
    adobeAccount: types_1.FilterC,
    orgImage: types_1.FilterC,
    sitemaps: types_1.FilterC,
    cookieConsent: types_1.FilterC,
    platform: types_1.FilterC,
    server: types_1.FilterC,
    host: types_1.FilterC,
    domainKeywords: types_1.FilterC,
    description: types_1.FilterC,
    toolCookiebot: types_1.FilterC,
    toolCookielaw: types_1.FilterC,
    toolOnetrust: types_1.FilterC,
    toolDoubleclick: types_1.FilterC,
    toolHotjar: types_1.FilterC,
    toolOptimizely: types_1.FilterC,
    toolEbbot: types_1.FilterC,
    toolIntercom: types_1.FilterC,
    toolKlaviyo: types_1.FilterC,
    toolHubspot: types_1.FilterC,
    toolMarketo: types_1.FilterC,
    toolSalesforce: types_1.FilterC,
    toolTrustpilot: types_1.FilterC,
    toolCustobar: types_1.FilterC,
    toolVoyado: types_1.FilterC,
    toolGodaddy: types_1.FilterC,
    toolShopify: types_1.FilterC,
    toolSquarespace: types_1.FilterC,
    toolWix: types_1.FilterC,
    toolWordpress: types_1.FilterC,
    toolSeenthis: types_1.FilterC,
    toolYotpo: types_1.FilterC,
    toolApprl: types_1.FilterC,
    toolCriteo: types_1.FilterC,
    toolReco: types_1.FilterC,
    requestedHosts: types_1.FilterC,
    analyticsGtm: types_1.FilterC,
    analyticsAw: types_1.FilterC,
    toolGoogletagmanager: types_1.FilterC,
    sizeDocument: types_1.FilterC,
    sizeScript: types_1.FilterC,
    sizeStylesheet: types_1.FilterC,
    sizeImage: types_1.FilterC,
    sizeMedia: types_1.FilterC,
    title: types_1.FilterC,
    favicon: types_1.FilterC,
    canonical: types_1.FilterC,
    robots: types_1.FilterC,
    noindex: types_1.FilterC,
    internalLinks: types_1.FilterC,
    externalLinks: types_1.FilterC,
    analyticsMo: types_1.FilterC,
    lang: types_1.FilterC,
    analyticsAdobe: types_1.FilterC,
    colorsFont: types_1.FilterC,
    colorsPage: types_1.FilterC,
    colorsSvg: types_1.FilterC,
    accessViolationScore: types_1.FilterC,
    violations: types_1.FilterC,
    imgAltRatio: types_1.FilterC,
    analyticsOpt: types_1.FilterC,
    analyticsAmplitude: types_1.FilterC,
    analyticsSnowplow: types_1.FilterC,
    snapchatHandle: types_1.FilterC,
    instagramHandle: types_1.FilterC,
    instagramIsVerified: types_1.FilterC,
    bio: types_1.FilterC,
    profilePictureUrl: types_1.FilterC,
    followersCount: types_1.FilterC,
    followingCount: types_1.FilterC,
    postCount: types_1.FilterC,
    linkedinIsVerified: types_1.FilterC,
    linkedinId: types_1.FilterC,
    linkedinDomain: types_1.FilterC,
    linkedinIndustry: types_1.FilterC,
    linkedinSysPeriod: types_1.FilterC,
    linkedinNumberOfEmployees: types_1.FilterC,
    linkedinNumberOfEmployees1WeekAgo: types_1.FilterC,
    linkedinNumberOfEmployees1MonthAgo: types_1.FilterC,
    linkedinNumberOfEmployees6MonthsAgo: types_1.FilterC,
    linkedinNumberOfEmployees1YearAgo: types_1.FilterC,
    linkedinNumberOfEmployees3YearsAgo: types_1.FilterC,
    linkedinNumberOfEmployees5YearsAgo: types_1.FilterC,
    linkedinNumberOfEmployeesGrowth1Week: types_1.FilterC,
    linkedinNumberOfEmployeesGrowth1Month: types_1.FilterC,
    linkedinNumberOfEmployeesGrowth6Months: types_1.FilterC,
    linkedinNumberOfEmployeesGrowth1Year: types_1.FilterC,
    linkedinNumberOfEmployeesGrowth3Years: types_1.FilterC,
    linkedinNumberOfEmployeesGrowth5Years: types_1.FilterC,
    numberOfEmployees: types_1.FilterC,
    numberOfEmployeesSource: types_1.FilterC,
    clientCompanyOverlayClientId: types_1.FilterC,
    clientCompanyOverlayPropertyId: types_1.FilterC,
    clientCompanyOverlayValue: types_1.FilterC,
    clientCompanyOverlayProperty: types_1.FilterC,
    clientCompanyOverlayCreatedAt: types_1.FilterC,
    companyBuzzCount: types_1.FilterC,
    companyBuzzIsRaisingCapital: types_1.FilterC,
    companyBuzzIsIpo: types_1.FilterC,
    companyBuzzIsMerger: types_1.FilterC,
    companyBuzzIsMoving: types_1.FilterC,
    companyBuzzIsHiring: types_1.FilterC,
    companyBuzzIsFiring: types_1.FilterC,
    companyBuzzIsClosing: types_1.FilterC,
    companyBuzzIsOpening: types_1.FilterC,
    companyBuzzIsExpanding: types_1.FilterC,
    companyBuzzIsDownsizing: types_1.FilterC,
    companyBuzzIsRestructuring: types_1.FilterC,
    companyBuzzIsNewProductIntro: types_1.FilterC,
    companyBuzzHasMoved: types_1.FilterC,
    companyBuzzIsChangingCeo: types_1.FilterC,
    companyBuzzIsChangingBoard: types_1.FilterC,
    companyBuzzIsChangingManagementTeam: types_1.FilterC,
    mlLikelyToMoveProbability: types_1.FilterC,
    mlIsLikelyToMove: types_1.FilterC,
    moveInDateCurrentOffice: types_1.FilterC,
    moveDateOrLeaseExpirationDate: types_1.FilterC,
    moveDateOrLeaseExpirationDateIsWithinOneYear: types_1.FilterC,
    moveDateOrLeaseExpirationDateHasPassed: types_1.FilterC,
    isMoreThan5YearsSinceMoveInDateCurrentOffice: types_1.FilterC,
    nornormWebVisitorsLeadQuality: types_1.FilterC,
    nornormWebVisitorsNumberOfVisits: types_1.FilterC,
    nornormWebVisitorsCountryCode: types_1.FilterC,
    nornormWebVisitorsLastVisitDate: types_1.FilterC,
    nornormWebVisitorsFirstVisitDate: types_1.FilterC,
    activeJobpostsPerEmployee: types_1.FilterC,
});
const filtersEquals = true;
exports.WeightsC = t.partial({
    iso3166: t.array(types_1.FieldWeightC),
    orgnr: t.array(types_1.FieldWeightC),
    companyMasterSysPeriod: t.array(types_1.FieldWeightC),
    likelihoodToMoveScore: t.array(types_1.FieldWeightC),
    legalEntityType: t.array(types_1.FieldWeightC),
    address: t.array(types_1.FieldWeightC),
    zipcode: t.array(types_1.FieldWeightC),
    city: t.array(types_1.FieldWeightC),
    muncipality: t.array(types_1.FieldWeightC),
    county: t.array(types_1.FieldWeightC),
    region: t.array(types_1.FieldWeightC),
    website: t.array(types_1.FieldWeightC),
    phone: t.array(types_1.FieldWeightC),
    email: t.array(types_1.FieldWeightC),
    registrationDate: t.array(types_1.FieldWeightC),
    companyCategory: t.array(types_1.FieldWeightC),
    companyStructure: t.array(types_1.FieldWeightC),
    legalForm: t.array(types_1.FieldWeightC),
    listingType: t.array(types_1.FieldWeightC),
    descriptionEn: t.array(types_1.FieldWeightC),
    operationalStatus: t.array(types_1.FieldWeightC),
    owners: t.array(types_1.FieldWeightC),
    keyPersons: t.array(types_1.FieldWeightC),
    signatory: t.array(types_1.FieldWeightC),
    parentCompanyName: t.array(types_1.FieldWeightC),
    previousNames: t.array(types_1.FieldWeightC),
    accountantFirm: t.array(types_1.FieldWeightC),
    hasPrivateEquityOwner: t.array(types_1.FieldWeightC),
    privateEquityOwner: t.array(types_1.FieldWeightC),
    lfy: t.array(types_1.FieldWeightC),
    lrq: t.array(types_1.FieldWeightC),
    ceo: t.array(types_1.FieldWeightC),
    ceoBirthYear: t.array(types_1.FieldWeightC),
    chairman: t.array(types_1.FieldWeightC),
    chairmanBirthYear: t.array(types_1.FieldWeightC),
    hasShareIssues: t.array(types_1.FieldWeightC),
    numberOfOwners: t.array(types_1.FieldWeightC),
    numberOfShares: t.array(types_1.FieldWeightC),
    hasForeignUltimateParent: t.array(types_1.FieldWeightC),
    ultimateParentCompany: t.array(types_1.FieldWeightC),
    ultimateParentOrgNo: t.array(types_1.FieldWeightC),
    ultimateParentNetSales: t.array(types_1.FieldWeightC),
    companyName: t.array(types_1.FieldWeightC),
    sniClassification: t.array(types_1.FieldWeightC),
    sniClassificationCode: t.array(types_1.FieldWeightC),
    financialsUpdatedDate: t.array(types_1.FieldWeightC),
    lastUpdated: t.array(types_1.FieldWeightC),
    companyKeywords: t.array(types_1.FieldWeightC),
    fiscalYear: t.array(types_1.FieldWeightC),
    currency: t.array(types_1.FieldWeightC),
    netSales: t.array(types_1.FieldWeightC),
    costOfSales: t.array(types_1.FieldWeightC),
    grossProfit: t.array(types_1.FieldWeightC),
    administrativeExpenses: t.array(types_1.FieldWeightC),
    sellingExpenses: t.array(types_1.FieldWeightC),
    otherExternalExpenses: t.array(types_1.FieldWeightC),
    personelExpenses: t.array(types_1.FieldWeightC),
    ebit: t.array(types_1.FieldWeightC),
    ebita: t.array(types_1.FieldWeightC),
    ebitd: t.array(types_1.FieldWeightC),
    ebitda: t.array(types_1.FieldWeightC),
    deprAmo: t.array(types_1.FieldWeightC),
    depreciation: t.array(types_1.FieldWeightC),
    amortisation: t.array(types_1.FieldWeightC),
    netFinancialIncomeOrExpenses: t.array(types_1.FieldWeightC),
    financialIncome: t.array(types_1.FieldWeightC),
    financialExpenses: t.array(types_1.FieldWeightC),
    preTaxProfit: t.array(types_1.FieldWeightC),
    netProfit: t.array(types_1.FieldWeightC),
    cashEquivalents: t.array(types_1.FieldWeightC),
    accRec: t.array(types_1.FieldWeightC),
    inventories: t.array(types_1.FieldWeightC),
    othCurrOpAss: t.array(types_1.FieldWeightC),
    currFinAss: t.array(types_1.FieldWeightC),
    totalCurrentAssets: t.array(types_1.FieldWeightC),
    ppe: t.array(types_1.FieldWeightC),
    goodwillIntangAss: t.array(types_1.FieldWeightC),
    nCurrFinRec: t.array(types_1.FieldWeightC),
    othNCurrOpAss: t.array(types_1.FieldWeightC),
    totalNonCurrentAssets: t.array(types_1.FieldWeightC),
    totalAssets: t.array(types_1.FieldWeightC),
    accPay: t.array(types_1.FieldWeightC),
    currFinLiab: t.array(types_1.FieldWeightC),
    postEmplLiab: t.array(types_1.FieldWeightC),
    othCurrOpLiab: t.array(types_1.FieldWeightC),
    totalCurrentLiabilities: t.array(types_1.FieldWeightC),
    othNCurrOpLiab: t.array(types_1.FieldWeightC),
    nCurrFinLiab: t.array(types_1.FieldWeightC),
    totalNonCurrLiab: t.array(types_1.FieldWeightC),
    shareholdEq: t.array(types_1.FieldWeightC),
    retainedEarnings: t.array(types_1.FieldWeightC),
    minInt: t.array(types_1.FieldWeightC),
    totalEquity: t.array(types_1.FieldWeightC),
    dividends: t.array(types_1.FieldWeightC),
    cashFlowBeforeFinAct: t.array(types_1.FieldWeightC),
    cashFlowOperating: t.array(types_1.FieldWeightC),
    ebitMargin: t.array(types_1.FieldWeightC),
    ebitdaMargin: t.array(types_1.FieldWeightC),
    preTaxProfitMargin: t.array(types_1.FieldWeightC),
    netProfitMargin: t.array(types_1.FieldWeightC),
    roe: t.array(types_1.FieldWeightC),
    netCapex: t.array(types_1.FieldWeightC),
    netDebt: t.array(types_1.FieldWeightC),
    marketCap: t.array(types_1.FieldWeightC),
    annualReportNumberOfEmployees: t.array(types_1.FieldWeightC),
    fiscalYearLength: t.array(types_1.FieldWeightC),
    lfyMonth: t.array(types_1.FieldWeightC),
    netChangeInCash: t.array(types_1.FieldWeightC),
    netSalesGrowth: t.array(types_1.FieldWeightC),
    cagr: t.array(types_1.FieldWeightC),
    cagr3: t.array(types_1.FieldWeightC),
    ebitGrowth: t.array(types_1.FieldWeightC),
    cagr3ebit: t.array(types_1.FieldWeightC),
    cagrebit: t.array(types_1.FieldWeightC),
    ebitdaGrowth: t.array(types_1.FieldWeightC),
    netProfitGrowth: t.array(types_1.FieldWeightC),
    eps: t.array(types_1.FieldWeightC),
    equityRatio: t.array(types_1.FieldWeightC),
    netDebtToEbit: t.array(types_1.FieldWeightC),
    netDebtToEbitda: t.array(types_1.FieldWeightC),
    netDebtToEquity: t.array(types_1.FieldWeightC),
    evToEbit: t.array(types_1.FieldWeightC),
    evToEbitda: t.array(types_1.FieldWeightC),
    evToNetSales: t.array(types_1.FieldWeightC),
    pe: t.array(types_1.FieldWeightC),
    ev: t.array(types_1.FieldWeightC),
    pbv: t.array(types_1.FieldWeightC),
    annualReportEmployeeGrowth: t.array(types_1.FieldWeightC),
    fiscalYearLength1YearAgo: t.array(types_1.FieldWeightC),
    fiscalYearLength3YearsAgo: t.array(types_1.FieldWeightC),
    fiscalYearLength5YearsAgo: t.array(types_1.FieldWeightC),
    lfyMonth1YearAgo: t.array(types_1.FieldWeightC),
    lfyMonth3YearsAgo: t.array(types_1.FieldWeightC),
    lfyMonth5YearsAgo: t.array(types_1.FieldWeightC),
    netChangeInCash1YearAgo: t.array(types_1.FieldWeightC),
    netChangeInCash3YearsAgo: t.array(types_1.FieldWeightC),
    netChangeInCash5YearsAgo: t.array(types_1.FieldWeightC),
    netSalesGrowth1YearAgo: t.array(types_1.FieldWeightC),
    netSalesGrowth3YearsAgo: t.array(types_1.FieldWeightC),
    netSalesGrowth5YearsAgo: t.array(types_1.FieldWeightC),
    cagr1YearAgo: t.array(types_1.FieldWeightC),
    cagr3YearsAgo: t.array(types_1.FieldWeightC),
    cagr5YearsAgo: t.array(types_1.FieldWeightC),
    cagr31YearAgo: t.array(types_1.FieldWeightC),
    cagr33YearsAgo: t.array(types_1.FieldWeightC),
    cagr35YearsAgo: t.array(types_1.FieldWeightC),
    ebitGrowth1YearAgo: t.array(types_1.FieldWeightC),
    ebitGrowth3YearsAgo: t.array(types_1.FieldWeightC),
    ebitGrowth5YearsAgo: t.array(types_1.FieldWeightC),
    cagr3ebit1YearAgo: t.array(types_1.FieldWeightC),
    cagr3ebit3YearsAgo: t.array(types_1.FieldWeightC),
    cagr3ebit5YearsAgo: t.array(types_1.FieldWeightC),
    cagrebit1YearAgo: t.array(types_1.FieldWeightC),
    cagrebit3YearsAgo: t.array(types_1.FieldWeightC),
    cagrebit5YearsAgo: t.array(types_1.FieldWeightC),
    ebitdaGrowth1YearAgo: t.array(types_1.FieldWeightC),
    ebitdaGrowth3YearsAgo: t.array(types_1.FieldWeightC),
    ebitdaGrowth5YearsAgo: t.array(types_1.FieldWeightC),
    netProfitGrowth1YearAgo: t.array(types_1.FieldWeightC),
    netProfitGrowth3YearsAgo: t.array(types_1.FieldWeightC),
    netProfitGrowth5YearsAgo: t.array(types_1.FieldWeightC),
    eps1YearAgo: t.array(types_1.FieldWeightC),
    eps3YearsAgo: t.array(types_1.FieldWeightC),
    eps5YearsAgo: t.array(types_1.FieldWeightC),
    equityRatio1YearAgo: t.array(types_1.FieldWeightC),
    equityRatio3YearsAgo: t.array(types_1.FieldWeightC),
    equityRatio5YearsAgo: t.array(types_1.FieldWeightC),
    netDebtToEbit1YearAgo: t.array(types_1.FieldWeightC),
    netDebtToEbit3YearsAgo: t.array(types_1.FieldWeightC),
    netDebtToEbit5YearsAgo: t.array(types_1.FieldWeightC),
    netDebtToEbitda1YearAgo: t.array(types_1.FieldWeightC),
    netDebtToEbitda3YearsAgo: t.array(types_1.FieldWeightC),
    netDebtToEbitda5YearsAgo: t.array(types_1.FieldWeightC),
    netDebtToEquity1YearAgo: t.array(types_1.FieldWeightC),
    netDebtToEquity3YearsAgo: t.array(types_1.FieldWeightC),
    netDebtToEquity5YearsAgo: t.array(types_1.FieldWeightC),
    evToEbit1YearAgo: t.array(types_1.FieldWeightC),
    evToEbit3YearsAgo: t.array(types_1.FieldWeightC),
    evToEbit5YearsAgo: t.array(types_1.FieldWeightC),
    evToEbitda1YearAgo: t.array(types_1.FieldWeightC),
    evToEbitda3YearsAgo: t.array(types_1.FieldWeightC),
    evToEbitda5YearsAgo: t.array(types_1.FieldWeightC),
    evToNetSales1YearAgo: t.array(types_1.FieldWeightC),
    evToNetSales3YearsAgo: t.array(types_1.FieldWeightC),
    evToNetSales5YearsAgo: t.array(types_1.FieldWeightC),
    pe1YearAgo: t.array(types_1.FieldWeightC),
    pe3YearsAgo: t.array(types_1.FieldWeightC),
    pe5YearsAgo: t.array(types_1.FieldWeightC),
    ev1YearAgo: t.array(types_1.FieldWeightC),
    ev3YearsAgo: t.array(types_1.FieldWeightC),
    ev5YearsAgo: t.array(types_1.FieldWeightC),
    pbv1YearAgo: t.array(types_1.FieldWeightC),
    pbv3YearsAgo: t.array(types_1.FieldWeightC),
    pbv5YearsAgo: t.array(types_1.FieldWeightC),
    annualReportEmployeeGrowth1YearAgo: t.array(types_1.FieldWeightC),
    annualReportEmployeeGrowth3YearsAgo: t.array(types_1.FieldWeightC),
    annualReportEmployeeGrowth5YearsAgo: t.array(types_1.FieldWeightC),
    netSales1YearAgo: t.array(types_1.FieldWeightC),
    netSales3YearsAgo: t.array(types_1.FieldWeightC),
    netSales5YearsAgo: t.array(types_1.FieldWeightC),
    costOfSales1YearAgo: t.array(types_1.FieldWeightC),
    costOfSales3YearsAgo: t.array(types_1.FieldWeightC),
    costOfSales5YearsAgo: t.array(types_1.FieldWeightC),
    grossProfit1YearAgo: t.array(types_1.FieldWeightC),
    grossProfit3YearsAgo: t.array(types_1.FieldWeightC),
    grossProfit5YearsAgo: t.array(types_1.FieldWeightC),
    administrativeExpenses1YearAgo: t.array(types_1.FieldWeightC),
    administrativeExpenses3YearsAgo: t.array(types_1.FieldWeightC),
    administrativeExpenses5YearsAgo: t.array(types_1.FieldWeightC),
    sellingExpenses1YearAgo: t.array(types_1.FieldWeightC),
    sellingExpenses3YearsAgo: t.array(types_1.FieldWeightC),
    sellingExpenses5YearsAgo: t.array(types_1.FieldWeightC),
    otherExternalExpenses1YearAgo: t.array(types_1.FieldWeightC),
    otherExternalExpenses3YearsAgo: t.array(types_1.FieldWeightC),
    otherExternalExpenses5YearsAgo: t.array(types_1.FieldWeightC),
    personelExpenses1YearAgo: t.array(types_1.FieldWeightC),
    personelExpenses3YearsAgo: t.array(types_1.FieldWeightC),
    personelExpenses5YearsAgo: t.array(types_1.FieldWeightC),
    ebit1YearAgo: t.array(types_1.FieldWeightC),
    ebit3YearsAgo: t.array(types_1.FieldWeightC),
    ebit5YearsAgo: t.array(types_1.FieldWeightC),
    ebita1YearAgo: t.array(types_1.FieldWeightC),
    ebita3YearsAgo: t.array(types_1.FieldWeightC),
    ebita5YearsAgo: t.array(types_1.FieldWeightC),
    ebitd1YearAgo: t.array(types_1.FieldWeightC),
    ebitd3YearsAgo: t.array(types_1.FieldWeightC),
    ebitd5YearsAgo: t.array(types_1.FieldWeightC),
    ebitda1YearAgo: t.array(types_1.FieldWeightC),
    ebitda3YearsAgo: t.array(types_1.FieldWeightC),
    ebitda5YearsAgo: t.array(types_1.FieldWeightC),
    deprAmo1YearAgo: t.array(types_1.FieldWeightC),
    deprAmo3YearsAgo: t.array(types_1.FieldWeightC),
    deprAmo5YearsAgo: t.array(types_1.FieldWeightC),
    depreciation1YearAgo: t.array(types_1.FieldWeightC),
    depreciation3YearsAgo: t.array(types_1.FieldWeightC),
    depreciation5YearsAgo: t.array(types_1.FieldWeightC),
    amortisation1YearAgo: t.array(types_1.FieldWeightC),
    amortisation3YearsAgo: t.array(types_1.FieldWeightC),
    amortisation5YearsAgo: t.array(types_1.FieldWeightC),
    netFinancialIncomeOrExpenses1YearAgo: t.array(types_1.FieldWeightC),
    netFinancialIncomeOrExpenses3YearsAgo: t.array(types_1.FieldWeightC),
    netFinancialIncomeOrExpenses5YearsAgo: t.array(types_1.FieldWeightC),
    financialIncome1YearAgo: t.array(types_1.FieldWeightC),
    financialIncome3YearsAgo: t.array(types_1.FieldWeightC),
    financialIncome5YearsAgo: t.array(types_1.FieldWeightC),
    financialExpenses1YearAgo: t.array(types_1.FieldWeightC),
    financialExpenses3YearsAgo: t.array(types_1.FieldWeightC),
    financialExpenses5YearsAgo: t.array(types_1.FieldWeightC),
    preTaxProfit1YearAgo: t.array(types_1.FieldWeightC),
    preTaxProfit3YearsAgo: t.array(types_1.FieldWeightC),
    preTaxProfit5YearsAgo: t.array(types_1.FieldWeightC),
    netProfit1YearAgo: t.array(types_1.FieldWeightC),
    netProfit3YearsAgo: t.array(types_1.FieldWeightC),
    netProfit5YearsAgo: t.array(types_1.FieldWeightC),
    cashEquivalents1YearAgo: t.array(types_1.FieldWeightC),
    cashEquivalents3YearsAgo: t.array(types_1.FieldWeightC),
    cashEquivalents5YearsAgo: t.array(types_1.FieldWeightC),
    accRec1YearAgo: t.array(types_1.FieldWeightC),
    accRec3YearsAgo: t.array(types_1.FieldWeightC),
    accRec5YearsAgo: t.array(types_1.FieldWeightC),
    inventories1YearAgo: t.array(types_1.FieldWeightC),
    inventories3YearsAgo: t.array(types_1.FieldWeightC),
    inventories5YearsAgo: t.array(types_1.FieldWeightC),
    othCurrOpAss1YearAgo: t.array(types_1.FieldWeightC),
    othCurrOpAss3YearsAgo: t.array(types_1.FieldWeightC),
    othCurrOpAss5YearsAgo: t.array(types_1.FieldWeightC),
    currFinAss1YearAgo: t.array(types_1.FieldWeightC),
    currFinAss3YearsAgo: t.array(types_1.FieldWeightC),
    currFinAss5YearsAgo: t.array(types_1.FieldWeightC),
    totalCurrentAssets1YearAgo: t.array(types_1.FieldWeightC),
    totalCurrentAssets3YearsAgo: t.array(types_1.FieldWeightC),
    totalCurrentAssets5YearsAgo: t.array(types_1.FieldWeightC),
    ppe1YearAgo: t.array(types_1.FieldWeightC),
    ppe3YearsAgo: t.array(types_1.FieldWeightC),
    ppe5YearsAgo: t.array(types_1.FieldWeightC),
    goodwillIntangAss1YearAgo: t.array(types_1.FieldWeightC),
    goodwillIntangAss3YearsAgo: t.array(types_1.FieldWeightC),
    goodwillIntangAss5YearsAgo: t.array(types_1.FieldWeightC),
    nCurrFinRec1YearAgo: t.array(types_1.FieldWeightC),
    nCurrFinRec3YearsAgo: t.array(types_1.FieldWeightC),
    nCurrFinRec5YearsAgo: t.array(types_1.FieldWeightC),
    othNCurrOpAss1YearAgo: t.array(types_1.FieldWeightC),
    othNCurrOpAss3YearsAgo: t.array(types_1.FieldWeightC),
    othNCurrOpAss5YearsAgo: t.array(types_1.FieldWeightC),
    totalNonCurrentAssets1YearAgo: t.array(types_1.FieldWeightC),
    totalNonCurrentAssets3YearsAgo: t.array(types_1.FieldWeightC),
    totalNonCurrentAssets5YearsAgo: t.array(types_1.FieldWeightC),
    totalAssets1YearAgo: t.array(types_1.FieldWeightC),
    totalAssets3YearsAgo: t.array(types_1.FieldWeightC),
    totalAssets5YearsAgo: t.array(types_1.FieldWeightC),
    accPay1YearAgo: t.array(types_1.FieldWeightC),
    accPay3YearsAgo: t.array(types_1.FieldWeightC),
    accPay5YearsAgo: t.array(types_1.FieldWeightC),
    currFinLiab1YearAgo: t.array(types_1.FieldWeightC),
    currFinLiab3YearsAgo: t.array(types_1.FieldWeightC),
    currFinLiab5YearsAgo: t.array(types_1.FieldWeightC),
    postEmplLiab1YearAgo: t.array(types_1.FieldWeightC),
    postEmplLiab3YearsAgo: t.array(types_1.FieldWeightC),
    postEmplLiab5YearsAgo: t.array(types_1.FieldWeightC),
    othCurrOpLiab1YearAgo: t.array(types_1.FieldWeightC),
    othCurrOpLiab3YearsAgo: t.array(types_1.FieldWeightC),
    othCurrOpLiab5YearsAgo: t.array(types_1.FieldWeightC),
    totalCurrentLiabilities1YearAgo: t.array(types_1.FieldWeightC),
    totalCurrentLiabilities3YearsAgo: t.array(types_1.FieldWeightC),
    totalCurrentLiabilities5YearsAgo: t.array(types_1.FieldWeightC),
    othNCurrOpLiab1YearAgo: t.array(types_1.FieldWeightC),
    othNCurrOpLiab3YearsAgo: t.array(types_1.FieldWeightC),
    othNCurrOpLiab5YearsAgo: t.array(types_1.FieldWeightC),
    nCurrFinLiab1YearAgo: t.array(types_1.FieldWeightC),
    nCurrFinLiab3YearsAgo: t.array(types_1.FieldWeightC),
    nCurrFinLiab5YearsAgo: t.array(types_1.FieldWeightC),
    totalNonCurrLiab1YearAgo: t.array(types_1.FieldWeightC),
    totalNonCurrLiab3YearsAgo: t.array(types_1.FieldWeightC),
    totalNonCurrLiab5YearsAgo: t.array(types_1.FieldWeightC),
    shareholdEq1YearAgo: t.array(types_1.FieldWeightC),
    shareholdEq3YearsAgo: t.array(types_1.FieldWeightC),
    shareholdEq5YearsAgo: t.array(types_1.FieldWeightC),
    retainedEarnings1YearAgo: t.array(types_1.FieldWeightC),
    retainedEarnings3YearsAgo: t.array(types_1.FieldWeightC),
    retainedEarnings5YearsAgo: t.array(types_1.FieldWeightC),
    minInt1YearAgo: t.array(types_1.FieldWeightC),
    minInt3YearsAgo: t.array(types_1.FieldWeightC),
    minInt5YearsAgo: t.array(types_1.FieldWeightC),
    totalEquity1YearAgo: t.array(types_1.FieldWeightC),
    totalEquity3YearsAgo: t.array(types_1.FieldWeightC),
    totalEquity5YearsAgo: t.array(types_1.FieldWeightC),
    dividends1YearAgo: t.array(types_1.FieldWeightC),
    dividends3YearsAgo: t.array(types_1.FieldWeightC),
    dividends5YearsAgo: t.array(types_1.FieldWeightC),
    cashFlowBeforeFinAct1YearAgo: t.array(types_1.FieldWeightC),
    cashFlowBeforeFinAct3YearsAgo: t.array(types_1.FieldWeightC),
    cashFlowBeforeFinAct5YearsAgo: t.array(types_1.FieldWeightC),
    cashFlowOperating1YearAgo: t.array(types_1.FieldWeightC),
    cashFlowOperating3YearsAgo: t.array(types_1.FieldWeightC),
    cashFlowOperating5YearsAgo: t.array(types_1.FieldWeightC),
    ebitMargin1YearAgo: t.array(types_1.FieldWeightC),
    ebitMargin3YearsAgo: t.array(types_1.FieldWeightC),
    ebitMargin5YearsAgo: t.array(types_1.FieldWeightC),
    ebitdaMargin1YearAgo: t.array(types_1.FieldWeightC),
    ebitdaMargin3YearsAgo: t.array(types_1.FieldWeightC),
    ebitdaMargin5YearsAgo: t.array(types_1.FieldWeightC),
    preTaxProfitMargin1YearAgo: t.array(types_1.FieldWeightC),
    preTaxProfitMargin3YearsAgo: t.array(types_1.FieldWeightC),
    preTaxProfitMargin5YearsAgo: t.array(types_1.FieldWeightC),
    netProfitMargin1YearAgo: t.array(types_1.FieldWeightC),
    netProfitMargin3YearsAgo: t.array(types_1.FieldWeightC),
    netProfitMargin5YearsAgo: t.array(types_1.FieldWeightC),
    roe1YearAgo: t.array(types_1.FieldWeightC),
    roe3YearsAgo: t.array(types_1.FieldWeightC),
    roe5YearsAgo: t.array(types_1.FieldWeightC),
    netCapex1YearAgo: t.array(types_1.FieldWeightC),
    netCapex3YearsAgo: t.array(types_1.FieldWeightC),
    netCapex5YearsAgo: t.array(types_1.FieldWeightC),
    netDebt1YearAgo: t.array(types_1.FieldWeightC),
    netDebt3YearsAgo: t.array(types_1.FieldWeightC),
    netDebt5YearsAgo: t.array(types_1.FieldWeightC),
    marketCap1YearAgo: t.array(types_1.FieldWeightC),
    marketCap3YearsAgo: t.array(types_1.FieldWeightC),
    marketCap5YearsAgo: t.array(types_1.FieldWeightC),
    annualReportNumberOfEmployees1YearAgo: t.array(types_1.FieldWeightC),
    annualReportNumberOfEmployees3YearsAgo: t.array(types_1.FieldWeightC),
    annualReportNumberOfEmployees5YearsAgo: t.array(types_1.FieldWeightC),
    netSalesGrowth1Year: t.array(types_1.FieldWeightC),
    netSalesGrowth3Years: t.array(types_1.FieldWeightC),
    netSalesGrowth5Years: t.array(types_1.FieldWeightC),
    costOfSalesGrowth1Year: t.array(types_1.FieldWeightC),
    costOfSalesGrowth3Years: t.array(types_1.FieldWeightC),
    costOfSalesGrowth5Years: t.array(types_1.FieldWeightC),
    grossProfitGrowth1Year: t.array(types_1.FieldWeightC),
    grossProfitGrowth3Years: t.array(types_1.FieldWeightC),
    grossProfitGrowth5Years: t.array(types_1.FieldWeightC),
    administrativeExpensesGrowth1Year: t.array(types_1.FieldWeightC),
    administrativeExpensesGrowth3Years: t.array(types_1.FieldWeightC),
    administrativeExpensesGrowth5Years: t.array(types_1.FieldWeightC),
    sellingExpensesGrowth1Year: t.array(types_1.FieldWeightC),
    sellingExpensesGrowth3Years: t.array(types_1.FieldWeightC),
    sellingExpensesGrowth5Years: t.array(types_1.FieldWeightC),
    otherExternalExpensesGrowth1Year: t.array(types_1.FieldWeightC),
    otherExternalExpensesGrowth3Years: t.array(types_1.FieldWeightC),
    otherExternalExpensesGrowth5Years: t.array(types_1.FieldWeightC),
    personelExpensesGrowth1Year: t.array(types_1.FieldWeightC),
    personelExpensesGrowth3Years: t.array(types_1.FieldWeightC),
    personelExpensesGrowth5Years: t.array(types_1.FieldWeightC),
    ebitGrowth1Year: t.array(types_1.FieldWeightC),
    ebitGrowth3Years: t.array(types_1.FieldWeightC),
    ebitGrowth5Years: t.array(types_1.FieldWeightC),
    ebitaGrowth1Year: t.array(types_1.FieldWeightC),
    ebitaGrowth3Years: t.array(types_1.FieldWeightC),
    ebitaGrowth5Years: t.array(types_1.FieldWeightC),
    ebitdGrowth1Year: t.array(types_1.FieldWeightC),
    ebitdGrowth3Years: t.array(types_1.FieldWeightC),
    ebitdGrowth5Years: t.array(types_1.FieldWeightC),
    ebitdaGrowth1Year: t.array(types_1.FieldWeightC),
    ebitdaGrowth3Years: t.array(types_1.FieldWeightC),
    ebitdaGrowth5Years: t.array(types_1.FieldWeightC),
    deprAmoGrowth1Year: t.array(types_1.FieldWeightC),
    deprAmoGrowth3Years: t.array(types_1.FieldWeightC),
    deprAmoGrowth5Years: t.array(types_1.FieldWeightC),
    depreciationGrowth1Year: t.array(types_1.FieldWeightC),
    depreciationGrowth3Years: t.array(types_1.FieldWeightC),
    depreciationGrowth5Years: t.array(types_1.FieldWeightC),
    amortisationGrowth1Year: t.array(types_1.FieldWeightC),
    amortisationGrowth3Years: t.array(types_1.FieldWeightC),
    amortisationGrowth5Years: t.array(types_1.FieldWeightC),
    netFinancialIncomeOrExpensesGrowth1Year: t.array(types_1.FieldWeightC),
    netFinancialIncomeOrExpensesGrowth3Years: t.array(types_1.FieldWeightC),
    netFinancialIncomeOrExpensesGrowth5Years: t.array(types_1.FieldWeightC),
    financialIncomeGrowth1Year: t.array(types_1.FieldWeightC),
    financialIncomeGrowth3Years: t.array(types_1.FieldWeightC),
    financialIncomeGrowth5Years: t.array(types_1.FieldWeightC),
    financialExpensesGrowth1Year: t.array(types_1.FieldWeightC),
    financialExpensesGrowth3Years: t.array(types_1.FieldWeightC),
    financialExpensesGrowth5Years: t.array(types_1.FieldWeightC),
    preTaxProfitGrowth1Year: t.array(types_1.FieldWeightC),
    preTaxProfitGrowth3Years: t.array(types_1.FieldWeightC),
    preTaxProfitGrowth5Years: t.array(types_1.FieldWeightC),
    netProfitGrowth1Year: t.array(types_1.FieldWeightC),
    netProfitGrowth3Years: t.array(types_1.FieldWeightC),
    netProfitGrowth5Years: t.array(types_1.FieldWeightC),
    cashEquivalentsGrowth1Year: t.array(types_1.FieldWeightC),
    cashEquivalentsGrowth3Years: t.array(types_1.FieldWeightC),
    cashEquivalentsGrowth5Years: t.array(types_1.FieldWeightC),
    accRecGrowth1Year: t.array(types_1.FieldWeightC),
    accRecGrowth3Years: t.array(types_1.FieldWeightC),
    accRecGrowth5Years: t.array(types_1.FieldWeightC),
    inventoriesGrowth1Year: t.array(types_1.FieldWeightC),
    inventoriesGrowth3Years: t.array(types_1.FieldWeightC),
    inventoriesGrowth5Years: t.array(types_1.FieldWeightC),
    othCurrOpAssGrowth1Year: t.array(types_1.FieldWeightC),
    othCurrOpAssGrowth3Years: t.array(types_1.FieldWeightC),
    othCurrOpAssGrowth5Years: t.array(types_1.FieldWeightC),
    currFinAssGrowth1Year: t.array(types_1.FieldWeightC),
    currFinAssGrowth3Years: t.array(types_1.FieldWeightC),
    currFinAssGrowth5Years: t.array(types_1.FieldWeightC),
    totalCurrentAssetsGrowth1Year: t.array(types_1.FieldWeightC),
    totalCurrentAssetsGrowth3Years: t.array(types_1.FieldWeightC),
    totalCurrentAssetsGrowth5Years: t.array(types_1.FieldWeightC),
    ppeGrowth1Year: t.array(types_1.FieldWeightC),
    ppeGrowth3Years: t.array(types_1.FieldWeightC),
    ppeGrowth5Years: t.array(types_1.FieldWeightC),
    goodwillIntangAssGrowth1Year: t.array(types_1.FieldWeightC),
    goodwillIntangAssGrowth3Years: t.array(types_1.FieldWeightC),
    goodwillIntangAssGrowth5Years: t.array(types_1.FieldWeightC),
    nCurrFinRecGrowth1Year: t.array(types_1.FieldWeightC),
    nCurrFinRecGrowth3Years: t.array(types_1.FieldWeightC),
    nCurrFinRecGrowth5Years: t.array(types_1.FieldWeightC),
    othNCurrOpAssGrowth1Year: t.array(types_1.FieldWeightC),
    othNCurrOpAssGrowth3Years: t.array(types_1.FieldWeightC),
    othNCurrOpAssGrowth5Years: t.array(types_1.FieldWeightC),
    totalNonCurrentAssetsGrowth1Year: t.array(types_1.FieldWeightC),
    totalNonCurrentAssetsGrowth3Years: t.array(types_1.FieldWeightC),
    totalNonCurrentAssetsGrowth5Years: t.array(types_1.FieldWeightC),
    totalAssetsGrowth1Year: t.array(types_1.FieldWeightC),
    totalAssetsGrowth3Years: t.array(types_1.FieldWeightC),
    totalAssetsGrowth5Years: t.array(types_1.FieldWeightC),
    accPayGrowth1Year: t.array(types_1.FieldWeightC),
    accPayGrowth3Years: t.array(types_1.FieldWeightC),
    accPayGrowth5Years: t.array(types_1.FieldWeightC),
    currFinLiabGrowth1Year: t.array(types_1.FieldWeightC),
    currFinLiabGrowth3Years: t.array(types_1.FieldWeightC),
    currFinLiabGrowth5Years: t.array(types_1.FieldWeightC),
    postEmplLiabGrowth1Year: t.array(types_1.FieldWeightC),
    postEmplLiabGrowth3Years: t.array(types_1.FieldWeightC),
    postEmplLiabGrowth5Years: t.array(types_1.FieldWeightC),
    othCurrOpLiabGrowth1Year: t.array(types_1.FieldWeightC),
    othCurrOpLiabGrowth3Years: t.array(types_1.FieldWeightC),
    othCurrOpLiabGrowth5Years: t.array(types_1.FieldWeightC),
    totalCurrentLiabilitiesGrowth1Year: t.array(types_1.FieldWeightC),
    totalCurrentLiabilitiesGrowth3Years: t.array(types_1.FieldWeightC),
    totalCurrentLiabilitiesGrowth5Years: t.array(types_1.FieldWeightC),
    othNCurrOpLiabGrowth1Year: t.array(types_1.FieldWeightC),
    othNCurrOpLiabGrowth3Years: t.array(types_1.FieldWeightC),
    othNCurrOpLiabGrowth5Years: t.array(types_1.FieldWeightC),
    nCurrFinLiabGrowth1Year: t.array(types_1.FieldWeightC),
    nCurrFinLiabGrowth3Years: t.array(types_1.FieldWeightC),
    nCurrFinLiabGrowth5Years: t.array(types_1.FieldWeightC),
    totalNonCurrLiabGrowth1Year: t.array(types_1.FieldWeightC),
    totalNonCurrLiabGrowth3Years: t.array(types_1.FieldWeightC),
    totalNonCurrLiabGrowth5Years: t.array(types_1.FieldWeightC),
    shareholdEqGrowth1Year: t.array(types_1.FieldWeightC),
    shareholdEqGrowth3Years: t.array(types_1.FieldWeightC),
    shareholdEqGrowth5Years: t.array(types_1.FieldWeightC),
    retainedEarningsGrowth1Year: t.array(types_1.FieldWeightC),
    retainedEarningsGrowth3Years: t.array(types_1.FieldWeightC),
    retainedEarningsGrowth5Years: t.array(types_1.FieldWeightC),
    minIntGrowth1Year: t.array(types_1.FieldWeightC),
    minIntGrowth3Years: t.array(types_1.FieldWeightC),
    minIntGrowth5Years: t.array(types_1.FieldWeightC),
    totalEquityGrowth1Year: t.array(types_1.FieldWeightC),
    totalEquityGrowth3Years: t.array(types_1.FieldWeightC),
    totalEquityGrowth5Years: t.array(types_1.FieldWeightC),
    dividendsGrowth1Year: t.array(types_1.FieldWeightC),
    dividendsGrowth3Years: t.array(types_1.FieldWeightC),
    dividendsGrowth5Years: t.array(types_1.FieldWeightC),
    cashFlowBeforeFinActGrowth1Year: t.array(types_1.FieldWeightC),
    cashFlowBeforeFinActGrowth3Years: t.array(types_1.FieldWeightC),
    cashFlowBeforeFinActGrowth5Years: t.array(types_1.FieldWeightC),
    cashFlowOperatingGrowth1Year: t.array(types_1.FieldWeightC),
    cashFlowOperatingGrowth3Years: t.array(types_1.FieldWeightC),
    cashFlowOperatingGrowth5Years: t.array(types_1.FieldWeightC),
    ebitMarginGrowth1Year: t.array(types_1.FieldWeightC),
    ebitMarginGrowth3Years: t.array(types_1.FieldWeightC),
    ebitMarginGrowth5Years: t.array(types_1.FieldWeightC),
    ebitdaMarginGrowth1Year: t.array(types_1.FieldWeightC),
    ebitdaMarginGrowth3Years: t.array(types_1.FieldWeightC),
    ebitdaMarginGrowth5Years: t.array(types_1.FieldWeightC),
    preTaxProfitMarginGrowth1Year: t.array(types_1.FieldWeightC),
    preTaxProfitMarginGrowth3Years: t.array(types_1.FieldWeightC),
    preTaxProfitMarginGrowth5Years: t.array(types_1.FieldWeightC),
    netProfitMarginGrowth1Year: t.array(types_1.FieldWeightC),
    netProfitMarginGrowth3Years: t.array(types_1.FieldWeightC),
    netProfitMarginGrowth5Years: t.array(types_1.FieldWeightC),
    roeGrowth1Year: t.array(types_1.FieldWeightC),
    roeGrowth3Years: t.array(types_1.FieldWeightC),
    roeGrowth5Years: t.array(types_1.FieldWeightC),
    netCapexGrowth1Year: t.array(types_1.FieldWeightC),
    netCapexGrowth3Years: t.array(types_1.FieldWeightC),
    netCapexGrowth5Years: t.array(types_1.FieldWeightC),
    netDebtGrowth1Year: t.array(types_1.FieldWeightC),
    netDebtGrowth3Years: t.array(types_1.FieldWeightC),
    netDebtGrowth5Years: t.array(types_1.FieldWeightC),
    marketCapGrowth1Year: t.array(types_1.FieldWeightC),
    marketCapGrowth3Years: t.array(types_1.FieldWeightC),
    marketCapGrowth5Years: t.array(types_1.FieldWeightC),
    annualReportNumberOfEmployeesGrowth1Year: t.array(types_1.FieldWeightC),
    annualReportNumberOfEmployeesGrowth3Years: t.array(types_1.FieldWeightC),
    annualReportNumberOfEmployeesGrowth5Years: t.array(types_1.FieldWeightC),
    activeJobposts: t.array(types_1.FieldWeightC),
    activeJobposts1WeekAgo: t.array(types_1.FieldWeightC),
    activeJobposts1MonthAgo: t.array(types_1.FieldWeightC),
    activeJobposts6MonthsAgo: t.array(types_1.FieldWeightC),
    activeJobposts1YearAgo: t.array(types_1.FieldWeightC),
    activeJobposts3YearsAgo: t.array(types_1.FieldWeightC),
    activeJobposts5YearsAgo: t.array(types_1.FieldWeightC),
    jobpostsGrowth1Week: t.array(types_1.FieldWeightC),
    jobpostsGrowth1Month: t.array(types_1.FieldWeightC),
    jobpostsGrowth6Months: t.array(types_1.FieldWeightC),
    jobpostsGrowth1Year: t.array(types_1.FieldWeightC),
    jobpostsGrowth3Years: t.array(types_1.FieldWeightC),
    jobpostsGrowth5Years: t.array(types_1.FieldWeightC),
    domainIsVerified: t.array(types_1.FieldWeightC),
    domain: t.array(types_1.FieldWeightC),
    error: t.array(types_1.FieldWeightC),
    pageLoadTimeTti: t.array(types_1.FieldWeightC),
    domainSysPeriod: t.array(types_1.FieldWeightC),
    ipAddress: t.array(types_1.FieldWeightC),
    analyticsUa: t.array(types_1.FieldWeightC),
    analyticsGa4: t.array(types_1.FieldWeightC),
    analyticsFb: t.array(types_1.FieldWeightC),
    gconvpAccount: t.array(types_1.FieldWeightC),
    adobeAccount: t.array(types_1.FieldWeightC),
    orgImage: t.array(types_1.FieldWeightC),
    sitemaps: t.array(types_1.FieldWeightC),
    cookieConsent: t.array(types_1.FieldWeightC),
    platform: t.array(types_1.FieldWeightC),
    server: t.array(types_1.FieldWeightC),
    host: t.array(types_1.FieldWeightC),
    domainKeywords: t.array(types_1.FieldWeightC),
    description: t.array(types_1.FieldWeightC),
    toolCookiebot: t.array(types_1.FieldWeightC),
    toolCookielaw: t.array(types_1.FieldWeightC),
    toolOnetrust: t.array(types_1.FieldWeightC),
    toolDoubleclick: t.array(types_1.FieldWeightC),
    toolHotjar: t.array(types_1.FieldWeightC),
    toolOptimizely: t.array(types_1.FieldWeightC),
    toolEbbot: t.array(types_1.FieldWeightC),
    toolIntercom: t.array(types_1.FieldWeightC),
    toolKlaviyo: t.array(types_1.FieldWeightC),
    toolHubspot: t.array(types_1.FieldWeightC),
    toolMarketo: t.array(types_1.FieldWeightC),
    toolSalesforce: t.array(types_1.FieldWeightC),
    toolTrustpilot: t.array(types_1.FieldWeightC),
    toolCustobar: t.array(types_1.FieldWeightC),
    toolVoyado: t.array(types_1.FieldWeightC),
    toolGodaddy: t.array(types_1.FieldWeightC),
    toolShopify: t.array(types_1.FieldWeightC),
    toolSquarespace: t.array(types_1.FieldWeightC),
    toolWix: t.array(types_1.FieldWeightC),
    toolWordpress: t.array(types_1.FieldWeightC),
    toolSeenthis: t.array(types_1.FieldWeightC),
    toolYotpo: t.array(types_1.FieldWeightC),
    toolApprl: t.array(types_1.FieldWeightC),
    toolCriteo: t.array(types_1.FieldWeightC),
    toolReco: t.array(types_1.FieldWeightC),
    requestedHosts: t.array(types_1.FieldWeightC),
    analyticsGtm: t.array(types_1.FieldWeightC),
    analyticsAw: t.array(types_1.FieldWeightC),
    toolGoogletagmanager: t.array(types_1.FieldWeightC),
    sizeDocument: t.array(types_1.FieldWeightC),
    sizeScript: t.array(types_1.FieldWeightC),
    sizeStylesheet: t.array(types_1.FieldWeightC),
    sizeImage: t.array(types_1.FieldWeightC),
    sizeMedia: t.array(types_1.FieldWeightC),
    title: t.array(types_1.FieldWeightC),
    favicon: t.array(types_1.FieldWeightC),
    canonical: t.array(types_1.FieldWeightC),
    robots: t.array(types_1.FieldWeightC),
    noindex: t.array(types_1.FieldWeightC),
    internalLinks: t.array(types_1.FieldWeightC),
    externalLinks: t.array(types_1.FieldWeightC),
    analyticsMo: t.array(types_1.FieldWeightC),
    lang: t.array(types_1.FieldWeightC),
    analyticsAdobe: t.array(types_1.FieldWeightC),
    colorsFont: t.array(types_1.FieldWeightC),
    colorsPage: t.array(types_1.FieldWeightC),
    colorsSvg: t.array(types_1.FieldWeightC),
    accessViolationScore: t.array(types_1.FieldWeightC),
    violations: t.array(types_1.FieldWeightC),
    imgAltRatio: t.array(types_1.FieldWeightC),
    analyticsOpt: t.array(types_1.FieldWeightC),
    analyticsAmplitude: t.array(types_1.FieldWeightC),
    analyticsSnowplow: t.array(types_1.FieldWeightC),
    snapchatHandle: t.array(types_1.FieldWeightC),
    instagramHandle: t.array(types_1.FieldWeightC),
    instagramIsVerified: t.array(types_1.FieldWeightC),
    bio: t.array(types_1.FieldWeightC),
    profilePictureUrl: t.array(types_1.FieldWeightC),
    followersCount: t.array(types_1.FieldWeightC),
    followingCount: t.array(types_1.FieldWeightC),
    postCount: t.array(types_1.FieldWeightC),
    linkedinIsVerified: t.array(types_1.FieldWeightC),
    linkedinId: t.array(types_1.FieldWeightC),
    linkedinDomain: t.array(types_1.FieldWeightC),
    linkedinIndustry: t.array(types_1.FieldWeightC),
    linkedinSysPeriod: t.array(types_1.FieldWeightC),
    linkedinNumberOfEmployees: t.array(types_1.FieldWeightC),
    linkedinNumberOfEmployees1WeekAgo: t.array(types_1.FieldWeightC),
    linkedinNumberOfEmployees1MonthAgo: t.array(types_1.FieldWeightC),
    linkedinNumberOfEmployees6MonthsAgo: t.array(types_1.FieldWeightC),
    linkedinNumberOfEmployees1YearAgo: t.array(types_1.FieldWeightC),
    linkedinNumberOfEmployees3YearsAgo: t.array(types_1.FieldWeightC),
    linkedinNumberOfEmployees5YearsAgo: t.array(types_1.FieldWeightC),
    linkedinNumberOfEmployeesGrowth1Week: t.array(types_1.FieldWeightC),
    linkedinNumberOfEmployeesGrowth1Month: t.array(types_1.FieldWeightC),
    linkedinNumberOfEmployeesGrowth6Months: t.array(types_1.FieldWeightC),
    linkedinNumberOfEmployeesGrowth1Year: t.array(types_1.FieldWeightC),
    linkedinNumberOfEmployeesGrowth3Years: t.array(types_1.FieldWeightC),
    linkedinNumberOfEmployeesGrowth5Years: t.array(types_1.FieldWeightC),
    numberOfEmployees: t.array(types_1.FieldWeightC),
    numberOfEmployeesSource: t.array(types_1.FieldWeightC),
    clientCompanyOverlayClientId: t.array(types_1.FieldWeightC),
    clientCompanyOverlayPropertyId: t.array(types_1.FieldWeightC),
    clientCompanyOverlayValue: t.array(types_1.FieldWeightC),
    clientCompanyOverlayProperty: t.array(types_1.FieldWeightC),
    clientCompanyOverlayCreatedAt: t.array(types_1.FieldWeightC),
    companyBuzzCount: t.array(types_1.FieldWeightC),
    companyBuzzIsRaisingCapital: t.array(types_1.FieldWeightC),
    companyBuzzIsIpo: t.array(types_1.FieldWeightC),
    companyBuzzIsMerger: t.array(types_1.FieldWeightC),
    companyBuzzIsMoving: t.array(types_1.FieldWeightC),
    companyBuzzIsHiring: t.array(types_1.FieldWeightC),
    companyBuzzIsFiring: t.array(types_1.FieldWeightC),
    companyBuzzIsClosing: t.array(types_1.FieldWeightC),
    companyBuzzIsOpening: t.array(types_1.FieldWeightC),
    companyBuzzIsExpanding: t.array(types_1.FieldWeightC),
    companyBuzzIsDownsizing: t.array(types_1.FieldWeightC),
    companyBuzzIsRestructuring: t.array(types_1.FieldWeightC),
    companyBuzzIsNewProductIntro: t.array(types_1.FieldWeightC),
    companyBuzzHasMoved: t.array(types_1.FieldWeightC),
    companyBuzzIsChangingCeo: t.array(types_1.FieldWeightC),
    companyBuzzIsChangingBoard: t.array(types_1.FieldWeightC),
    companyBuzzIsChangingManagementTeam: t.array(types_1.FieldWeightC),
    mlLikelyToMoveProbability: t.array(types_1.FieldWeightC),
    mlIsLikelyToMove: t.array(types_1.FieldWeightC),
    moveInDateCurrentOffice: t.array(types_1.FieldWeightC),
    moveDateOrLeaseExpirationDate: t.array(types_1.FieldWeightC),
    moveDateOrLeaseExpirationDateIsWithinOneYear: t.array(types_1.FieldWeightC),
    moveDateOrLeaseExpirationDateHasPassed: t.array(types_1.FieldWeightC),
    isMoreThan5YearsSinceMoveInDateCurrentOffice: t.array(types_1.FieldWeightC),
    nornormWebVisitorsLeadQuality: t.array(types_1.FieldWeightC),
    nornormWebVisitorsNumberOfVisits: t.array(types_1.FieldWeightC),
    nornormWebVisitorsCountryCode: t.array(types_1.FieldWeightC),
    nornormWebVisitorsLastVisitDate: t.array(types_1.FieldWeightC),
    nornormWebVisitorsFirstVisitDate: t.array(types_1.FieldWeightC),
    activeJobpostsPerEmployee: t.array(types_1.FieldWeightC),
});
const scoreEquals = true;
//# sourceMappingURL=generated.js.map